/* eslint-disable no-tabs */
/* eslint-disable no-mixed-spaces-and-tabs */
import {
  mdiForum,
  // mdiAccountBadge,
  mdiViewList,
  mdiAccountCheckOutline,
  mdiInformationOutline
} from '@mdi/js'

export default [
  {
    label: 'sidebarFin.comboard',
    // label: 'Comboard',
    to: '/comboard-dashboard',
    icon: mdiForum
  },
  {
    to: '/comboardlist',
    label: 'sidebarFin.comboardList',
    // label: 'Comboard List',
    icon: mdiViewList
  },
  {
    to: '/comboarduser',
    label: 'sidebarFin.comboardUser',
    // label: 'Comboard User',
    icon: mdiAccountCheckOutline
  },
  {
    to: '/comboardcategory',
    label: 'sidebarFin.comboardCategory',
    // label: 'Comboard Category',
    icon: mdiInformationOutline
  }
  // {
  //   to: '/comboardrecipients',
  //     label: 'Comboard Recipients',
  //     icon: mdiAccountBadge
  //   }
]
